"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FATAL_ERROR = void 0;

var _react = _interopRequireDefault(require("react"));

var _Message = _interopRequireDefault(require("@icare/components/lib/Message"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FATAL_ERROR = {
  title: 'A problem has occurred',
  type: _Message.default.type.ERROR,
  body: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "An internal error has occurred and we are unable to perform that action at this time."), /*#__PURE__*/_react.default.createElement("p", null, "Please contact us if this problem persists."))
};
exports.FATAL_ERROR = FATAL_ERROR;
var _default = {
  FATAL_ERROR: FATAL_ERROR
};
exports.default = _default;
//# sourceMappingURL=errorMessages.js.map